import { Alert, Box, Link, StatusIndicator } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import PortalServiceClient from '../../api/PortalServiceClient';
import constants from '../../common/constants';
import UserProfile from '../../model/UserProfile';

const mplServiceClient = MplServiceClientFactory.create();
const portalServiceClient = PortalServiceClient.create();

export const AuthorFinalizingInfo = (props: { contentId: string; workflowId: number }) => {
  const [finalizingCopies, setFinalizingCopies] = useState<UserProfile[]>();

  useEffect(() => {
    const listFinalizingCopies = async () => {
      const finalizingResult = await mplServiceClient.listFinalizing(
        props.contentId,
        props.workflowId,
      );
      const userProfiles = await portalServiceClient.getUserProfiles(finalizingResult.finalizerIds);
      setFinalizingCopies(userProfiles);
    };

    listFinalizingCopies();
  }, [props.contentId, props.workflowId]);

  const finalizingLinks =
    // @ts-expect-error TS18048 - strict migration
    finalizingCopies?.length > 0 ? (
      // @ts-expect-error TS18048 - strict migration
      finalizingCopies.map((fc) => (
        <Box key={fc.userId}>
          <Link
            href={`/content-finalizing-viewer/author/${props.contentId}/${props.workflowId}/${fc.userId}`}
            target="_blank"
          >
            {constants.WORKFLOW_AUTHOR_FINALIZING_CHANGES_PREFIX} {fc.name} ({fc.type})
          </Link>
        </Box>
      ))
    ) : (
      <StatusIndicator type="loading">
        {constants.WORKFLOW_AUTHOR_FINALIZING_LOADING}
      </StatusIndicator>
    );

  return (
    <Alert type="warning">
      <Box variant="p">{constants.WORKFLOW_AUTHOR_FINALIZING_INFO}</Box>
      {finalizingLinks}
    </Alert>
  );
};
